import { render, staticRenderFns } from "./add_edit.vue?vue&type=template&id=b115ad8c&scoped=true&"
import script from "./add_edit.vue?vue&type=script&lang=js&"
export * from "./add_edit.vue?vue&type=script&lang=js&"
import style0 from "./add_edit.vue?vue&type=style&index=0&id=b115ad8c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b115ad8c",
  null
  
)

export default component.exports